<div class="modal-header gchc-dialog">
  <!-- <h4 class="modal-title">PATRIMONIO CULTURAL INMATERIAL</h4> -->
  <div class="row">
    <div class="col-md-1">
      <img src="assets/img/LogoGCH-200px.png" alt="" class="img-fluid">
    </div>
    <div class="col-md-10">
      <div class="row">
        <div class="col-12"><h4 class="text-center font15">MUNICIPALIDAD PROVINCIAL DEL CUSCO - GERENCIA DEL CENTRO HISTORICO</h4></div>
        <div class="col-12"><h5 class="text-center font15">COMPONENTE PATRIMONIO Y CULTURA</h5></div>
      </div>
    </div>
    <div class="col-md-1">
      <img src="assets/img/muni_logo_banner_2021.png" alt="" class="img-fluid">
    </div>
  </div>
  <button type="button" class="close" aria-label="Cerrar" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body gchc-dialog">

  <div class="row">

    <div class="col-12">

      <!-- <div class="row">
        <div class="col-12">
          {{ ficha.codregistro }}
        </div>
      </div> -->
      


      <!-- <div class="row my-2">
        <div class="col-12">
          <img src="assets/img/secciones/inmaterial/{{ ficha.codregistro }}.jpg" class="img-fluid" />
        </div>
      </div> -->

      <div class="row p-1">
        <div class="col-md-6">
          
          <div class="row">
            <div class="col-sm-6 border bg-warning">
              NOMBRE DE LA MANIFESTACIÓN:
            </div>
            <div class="col-sm-6 border">
              {{ ficha.nombre_manifestacion }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 border bg-warning">
              NOMBRE DEL(LA) REPRESENTANTE:
            </div>
            <div class="col-sm-6 border">
              {{ ficha.nombre_representante }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="row">
                <div class="col-sm-6 border  bg-warning">
                  MARCO TEMPORAL:
                </div>
                <div class="col-sm-6 border ">
                  {{ ficha.mt_marco_temporal }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 border bg-warning">
                  FECHA DE CELEBRACION:
                </div>
                <div class="col-sm-6 border">
                  {{ ficha.mt_fecha_celebracion }}
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 border border-top-0 desc">
                  DESCRIPCION / OBSERVACIONES
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 border border-top-0">
                  <span [innerHTML]="ficha.mt_desc_obs"></span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 ">
              <div class="row">
                <div class="col-md-6 border bg-warning">
                  TEMA:
                </div>
                <div class="col-md-6 border ">
                  {{ ficha.tm_tema }}
                </div>
                <div class="col-md-12 border border-top-0 desc">
                  DESCRIPCION / OBSERVACIONES
                </div>
                <div class="col-md-12 border border-op-0">
                  <span [innerHTML]="ficha.tm_desc_obs"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-md-6 border bg-warning">
              MANIFESTACIÓN HERENCIA:
            </div>
            <div class="col-md-6 border">
              {{ficha.mh_manifestacion_herencia}}
            </div>
            <div class="col-md-6 border border-top-0 bg-warning">
              AÑO REFERENCIAL DE LA EXP. CULTURAL:
            </div>
            <div class="col-md-6 border border-top-0">
              {{ficha.mh_agno_ref_expresion_cultural}}
            </div>

            <div class="col-md-6 border border-top-0 bg-warning">
              TITULO:
            </div>
            <div class="col-md-6 border border-top-0">
              {{ficha.mh_titulo}}
            </div>
            <div class="col-md-12 border border-top-0 desc">
              DESCRIPCION / OBSERVACIONES:
            </div>
            <div class="col-md-12 border border-top-0">
              <span [innerHTML]="ficha.mh_descripcion"></span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-sm-12">
              
              <div class="row">
                <div class="col-md-6 border  bg-warning">
                  ESTADO ACTUAL:
                </div>
                <div class="col-md-6 border ">
                  {{ ficha.ea_estado_actual }}
                </div>
                <div class="col-md-12 border border-top-0 desc">
                  DESCRIPCION / OBSERVACIONES
                </div>
                <div class="col-md-12 border border-top-0">
                  <span [innerHTML]="ficha.ea_desc_obs"></span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="row">
                <div class="col-md-6 border bg-warning">
                  TRANSCENDENCIA CULTURAL / ALCANCE:
                </div>
                <div class="col-md-6 border">
                  {{ ficha.tca_trasc_cultural_alcance }}
                </div>
                <div class="col-md-12 border border-top-0 desc">
                  DESCRIPCION / OBSERVACIONES
                </div>
                <div class="col-md-12 border border-top-0">
                  <span [innerHTML]="ficha.tca_desc_obs"></span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-md-6">
          <div class="row my-2">
            <div class="col-12">
              <img src="assets/img/secciones/inmaterial/{{ ficha.codregistro }}.jpg" class="img-fluid" />
            </div>
          </div>
          
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6 border bg-warning">
              REGISTRO ELEMENTOS O PROCESOS QUE DESTACAN:
            </div>
            <div class="col-md-6 border">
              {{ficha.roepd1_element_destacables}}
            </div>
            <div class="col-md-12 border border-top-0 desc">
              DESCRIPCION / OBSERVACIONES:
            </div>
            <div class="col-md-12 border border-top-0">
              <span [innerHTML]="ficha.roepd1_desc_obs"></span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6 border bg-warning">
              REGISTRO ELEMENTOS O PROCESOS QUE DESTACAN:
            </div>
            <div class="col-md-6 border">
              {{ficha.roepd2_element_destacables}} 
            </div>
            <div class="col-md-12 border border-top-0 desc">
              DESCRIPCION / OBSERVACIONES: 
            </div>
            <div class="col-md-12 border border-top-0">
              <span [innerHTML]="ficha.roepd2_desc_obs"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6 border bg-warning">
              REGISTRO ELEMENTOS O PROCESOS QUE DESTACAN:
            </div>
            <div class="col-md-6 border">
              {{ficha.roepd3_element_destacables}}
            </div>
            <div class="col-md-12 border border-top-0 desc">
              DESCRIPCION / OBSERVACIONES:
            </div>
            <div class="col-md-12 border border-top-0">
              <span [innerHTML]="ficha.roepd3_desc_obs"></span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6 border bg-warning">
              OTROS USOS Y COSTUMBRES:
            </div>
            <div class="col-md-6 border">
              {{ficha.ouc_otros_usos_costumbres}}
            </div>
            <div class="col-md-12 border border-top-0 desc">
              DESCRIPCION / OBSERVACIONES: 
            </div>
            <div class="col-md-12 border border-top-0">
              <span [innerHTML]="ficha.ouc_desc_obs"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 border desc">
          DESCRIPCION / OBSERVACIONES:
        </div>
        <div class="col-12 border border-top-0">
          <span [innerHTML]="ficha.observaciones"></span>
        </div>
      </div>




    </div>
    <!-- <div class="row my-2">
      <div class="col-md-6 col-sm-12">
        <ul class="lista-rep-inma">
          <li>Coordinador responsable</li>
          <li>{{ficha.coord_nombre}}</li>
          <li>Catalogador(es) responsable(s)</li>
          <li>{{ficha.cata1_nombre}}</li>
          <li>{{ficha.cata2_nombre}}</li>
          <li>{{ficha.cata3_nombre}}</li>
        </ul>
      </div>
      <div class="row my-2">
        <div class="col-md-6 col-sm-12">
          <ul class="lista-rep-inma">
            <li>Fecha/Hora{{ficha.fecha}}</li>
          </ul>

        </div>
      </div>
    </div> -->
  </div>

  <!--***********************************************************************************-->
  <!-- <p>Mi nombre es {{ user!.nombre }}</p>
  <p>mi edad es de {{ user!.edad }} años</p>
  <p>{{ ficha.ubicacion_manifestacion }}</p> -->

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">
    Cerrar
  </button>
</div>